$(function () {
    $('a[href^="#"]').click(function() {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - document.querySelector('.page-header').offsetHeight
        }, 800);
        return false;
    });
});